import { object, string } from "yup"
import { ONE_TIME_PASSWORD } from "../regex/constants"
import { buildSchema } from "./util/build-schema"

export const oneTimePasswordSchema = string()
  .required()
  .matches(ONE_TIME_PASSWORD, {
    message: "yup.twoFactorMethod.oneTimePassword",
  })

const schema = object({
  oneTimePassword: oneTimePasswordSchema,
})

export const twoFactorMethodSchema = buildSchema("TwoFactorMethod", schema)
